import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})

export class StockService {

  constructor(private globalHelper:GlobalHelper, private httpclient: HttpClient) { }
  GetAllInventoryCategory():Observable<any>{   
    // let data='ObjEnquiry=' +strData;  
  var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllInventoryCategory?',{headers:reqHeader});

}
SaveInventoryItemCategory(strData):Observable<any>{   
  let data='InventoryItemCategoryList=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/SaveInventoryItemCategory?'+encodeURI(data),{headers:reqHeader});

}
GetAllInventoryItemCategory():Observable<any>{   
    
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllInventoryItemCategory?',{headers:reqHeader});

}
SaveInventoryItem(strData):Observable<any>{   
  let data='InventoryItemList=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/SaveInventoryItem?'+encodeURI(data),{headers:reqHeader});

}
InventoryItemMarkActive(strData):Observable<any>{   
  let data='InventoryItemList=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/InventoryItemMarkActive?'+encodeURI(data),{headers:reqHeader});

}
GetAllItem(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllItem?'+encodeURI(data),{headers:reqHeader});

}
SaveUOM(strData):Observable<any>{   
  let data='UOMList=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/SaveUOM?'+encodeURI(data),{headers:reqHeader});

}
GetAllUOM():Observable<any>{  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllUOM?',{headers:reqHeader});

}
SearchStockInformation(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/SearchStockInformation?'+encodeURI(data),{headers:reqHeader});

}
GetAllVendor(strData):Observable<any>{   
  let data='objModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllVendor?'+encodeURI(data),{headers:reqHeader});

}
SavePurchaseOrder(objPO,ObjItemList):Observable<any>{   
//   let data='objPO=' +objPO+'&ObjItemList='+ObjItemList;  
// var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
// return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/SavePurchaseOrder?'+encodeURI(data),{headers:reqHeader});
let formData = new FormData();
formData.append("objPO", objPO); 
formData.append("ObjItemList", ObjItemList);     
return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/SavePurchaseOrder', formData);

}
GetAllPurchaseOrder(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllPurchaseOrder?'+encodeURI(data),{headers:reqHeader});

}
GetAllPurchaseOrderForReciving(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllPurchaseOrderForReciving?'+encodeURI(data),{headers:reqHeader});

}
GetPurchaseOrderReceiving(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetPurchaseOrderReceiving?'+encodeURI(data),{headers:reqHeader});

}
CancelReceiving(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/CancelReceiving?'+encodeURI(data),{headers:reqHeader});

}
SavePurchaseOrderReceiving(data, ItemList, AssetItemList):Observable<any>{   
  let formData = new FormData();
  formData.append("objPOReceiving", data); 
  formData.append("ObjItemList", ItemList);
  formData.append("AssetItemList", AssetItemList);      
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/SavePurchaseOrderReceiving', formData);
}
GetAllPOReceiving(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllPOReceiving?'+encodeURI(data),{headers:reqHeader});

}
CancelInvoice(strData):Observable<any>{   
  let data='objInvoiceModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/CancelInvoice?'+encodeURI(data),{headers:reqHeader});

}
SavePurchaseReceivingInvoice(InvoiceModel, POReceivingList, ChargeTypeList, AssetsList, GRNItemList):Observable<any>{   
  let formData = new FormData();
  formData.append("objInvoiceModel", InvoiceModel); 
  formData.append("ObjPOReceivingList", POReceivingList);
  formData.append("ObjChargeTypeList", ChargeTypeList);  
  formData.append("AssetsList", AssetsList);     
  formData.append("GRNItemList", GRNItemList); 
 return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/SavePurchaseReceivingInvoice', formData);

}
GetAllPOReceivingPayment(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllPOReceivingPayment?'+encodeURI(data),{headers:reqHeader});

}
GetAllInvoice(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllInvoice?'+encodeURI(data),{headers:reqHeader});

}
GetAllGeneralInvoice(strData):Observable<any>{   
  let data='objFilter=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllGeneralInvoice?'+encodeURI(data),{headers:reqHeader});
}
CancelGeneralInvoice(strData):Observable<any>{   
  let data='objInvoiceModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/CancelGeneralInvoice?'+encodeURI(data),{headers:reqHeader});
}
SaveGeneralInvoice(strData):Observable<any>{   
  let data='objInvoiceModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/SaveGeneralInvoice?'+encodeURI(data),{headers:reqHeader});
}
GetInvoiceDueList(strData):Observable<any>{   
  let data='objInvoiceModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetInvoiceDueList?'+encodeURI(data),{headers:reqHeader});
}
GetAllPaymentList(strData):Observable<any>{   
  let data='objPaymentModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetAllPaymentList?'+encodeURI(data),{headers:reqHeader});
}
CancelPayment(strData):Observable<any>{   
  let data='objPaymentModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/CancelPayment?'+encodeURI(data),{headers:reqHeader});
}
GetInvoiceList(strData):Observable<any>{   
  let data='objInvoiceModel=' +strData;  
var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Stock/GetInvoiceList?'+encodeURI(data),{headers:reqHeader});
}
SavePOPayment(InvoiceModel, ObjIncoiveList):Observable<any>{  
  let formData = new FormData();
  formData.append("objInvoiceModel", InvoiceModel); 
  formData.append("ObjIncoiveList", ObjIncoiveList); 
 return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/SavePOPayment', formData);
 
}
GetAllStockStatement(InvoiceModel):Observable<any>{  
  let formData = new FormData();
  formData.append("obj", InvoiceModel);  
 return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/GetAllStockStatement', formData);
 
}

// Stock Adjustment

GetAllStockAdjustment(InvoiceModel):Observable<any>{  
  let formData = new FormData();
  formData.append("strmodel", InvoiceModel);  
 return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/GetAllStockAdjustment', formData);
 
}
UpdateStockAdjustment(InvoiceModel,objList):Observable<any>{  
  let formData = new FormData();
  formData.append("ObjModel", InvoiceModel);  
  formData.append("StockAdjustmentList", objList);  
 return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/UpdateStockAdjustment', formData);
 
}
GetStockAdjustment(InvoiceModel):Observable<any>{  
  let formData = new FormData();
  formData.append("StockAdjustmentModel", InvoiceModel);  
 return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Stock/GetStockAdjustment', formData);
 
}
}
